import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as RolePermssionActions from '@carm/_configs/store/actions/role-type-permission.actions';
import { Store } from '@ngrx/store';
import { Role, User, UserRole } from '../models';
import { AccessUserService } from '../services/access-user.service';
import * as UserActions from './user.actions';
import * as UserReducer from './user.reducer';

@Injectable()
export class UserEffects {

  constructor(private actions$: Actions,
      protected store: Store<UserReducer.State>,
      private accessUserService: AccessUserService) {}

  /**
   * Load user roles$ of user effects - call the userService to load the userRoles from backend and
   * dispatch loadSuccessful action or failure action in case of error
   */
  loadUserRoles$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.loadRoles),
      switchMap(() =>
        this.accessUserService.getUserRoles().pipe(
          map((data) =>  {
            return UserActions.loadRolesSuccess({ data });
          }),
          catchError((error) => of(UserActions.loadRolesFailure({ error })))),
      ),
    );
  });


  /**
   * Load user roles by setting new business as last selected business of user
   */
  loadUserRolesByBusiness$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.loadRoleByBusiness),
      switchMap((action) => this.accessUserService.setLastUsedBusiness(action.data.businessId).pipe(
        map((roleData) => UserActions.loadRolesSuccess({ data: roleData as { role: UserRole, user: User} })),
        catchError((error) => of(UserActions.loadRolesFailure({ error })))),
    ));
  });


  loadRoleSuccessByBusiness$ = createEffect(() => {
    return this.actions$.pipe(
     ofType(UserActions.loadRolesSuccess),
     switchMap(() => of(RolePermssionActions.loadPermissions()))
    )
  });


  loadNativeRoleSuccessByBusiness$ = createEffect(() => {
    return this.actions$.pipe(
     ofType(UserActions.loadNativeRolesSuccess),
     switchMap(({data}) => {
        let businessId = this.getBusinessFromRoles(data?.roles);
        return of(RolePermssionActions.loadNativeBusinessPermissions({data: {businessId}}));
     })
    )
  });

  getBusinessFromRoles(roles: Role[]){
    return roles && roles.length > 0
    ? roles[0].program?.companyUid
    : null;
  }


  /**
   * Load native roles of users
   */
  loadNativeRoles$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.loadNativeRoles),
      switchMap((action) =>
        this.accessUserService.getStaffRolesByBusiness(action.data.businessId).pipe(
          map((roles) => UserActions.loadNativeRolesSuccess( {data: {roles}})),
          catchError((error) => of(UserActions.loadNativeRolesFailure({ error })))),
      ),
    );
  });
}
